/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function DefaultWidth({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M0 8a.6.6 0 0 0 .6.6h4.551l-1.975 1.976a.6.6 0 0 0 .848.848l3-3a.6.6 0 0 0 0-.848l-3-3a.6.6 0 1 0-.848.848L5.15 7.4H.6A.6.6 0 0 0 0 8M15.2 8a.6.6 0 0 1-.6.6H10.05l1.976 1.976a.6.6 0 0 1-.85.848l-3-3a.6.6 0 0 1 0-.848l3-3a.6.6 0 0 1 .85.848L10.049 7.4H14.6a.6.6 0 0 1 .6.6" /></svg>;
}
;